import Api from 'libs/api/index';

class AcademyCategoriesApi extends Api {
  constructor() {
    super('retail_academy/academy_categories/');
  }
}

export default AcademyCategoriesApi;
